import React from 'react'
import propTypes from "prop-types"

const AgeResult = ({age}) => {
  return (
    <div ><br/>
      <h1 className="text-2xl font-bold dark:text-white">You are {age.years} years,{age.months} months,{age.days} days old</h1>
    </div>
  )
}
AgeResult.prototype={
    age: propTypes.shape({
        years:propTypes.number.isRequired,
        months:propTypes.number.isRequired,
        days:propTypes.number.isRequired
    })
    }

export default AgeResult
